export class Search {
  constructor(
      public anio_id: number,
      public mes_id: number,
  ) { }
}
